import { colors } from "@/shared/utils/colors";
import { ChartContainer, cn } from "@suns/design-system";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  XAxis,
  YAxis,
} from "recharts";

interface BarChartData {
  key: string;
  value: number | string;
  label: string;
}

export default function ScoreBarChart({
  scores,
  labels,
  className,
  tickFormatter,
  dataKey = "value",
  print = false,
}: {
  scores: BarChartData[];
  labels: string[] | number[];
  className?: string;
  tickFormatter?: (value: number) => string;
  dataKey?: string;
  print?: boolean;
}) {
  const barSize = print ? 16 : 22;
  const gap = print ? 4 : 4;
  const height = (scores.length + 1) * (barSize + gap * 2);

  return (
    <ChartContainer
      config={{}}
      className={cn("flex-1", className)}
      style={{ height }}
    >
      <BarChart
        data={scores}
        barSize={print ? 18 : 22}
        layout="vertical"
        margin={{
          left: print ? 0 : 10,
        }}
      >
        <CartesianGrid vertical={true} horizontal={false} stroke="#ddd" />
        <XAxis
          dataKey="value"
          type="number"
          hide={false}
          axisLine={false}
          stroke="#ddd"
          domain={[0, labels.length - 1]}
          ticks={labels}
          fontSize={print ? 10 : 12}
          tickFormatter={tickFormatter ? tickFormatter : undefined}
        />
        <YAxis
          dataKey="label"
          width={130}
          type="category"
          axisLine={false}
          tickLine={false}
          interval={0}
          fontSize={print ? 8 : 12}
        />
        <Bar
          dataKey="value"
          fill={colors.xihuitl}
          radius={4}
          barSize={barSize}
          minPointSize={36}
        >
          <LabelList
            dataKey={dataKey}
            position="insideLeft"
            className="fill-[white] font-bold"
            offset={8}
            formatter={(value: number) => {
              if (typeof value === "number") {
                return value.toFixed(1);
              }
              return value;
            }}
          />
        </Bar>
      </BarChart>
    </ChartContainer>
  );
}
